import { useEffect } from "react";
import { useCarConfigDispatch, useCarConfigSelector } from "../redux/store";
import { startConfigSave } from "../redux/slices/CarConfigSaveSlice";

const useAphTyCodeInit = (): void => {
    const dispatch = useCarConfigDispatch();
    const saving = useCarConfigSelector((state) => state.save.saving);
    const saved = useCarConfigSelector((state) => state.save.saved);
    const carConfigIsInitialized = useCarConfigSelector((state) => state.car.initialized && state.items.initialized);

    useEffect(() => {
        if (!saving && !saved && carConfigIsInitialized) {
            dispatch(startConfigSave());
        }
    }, [carConfigIsInitialized]);
};

export default useAphTyCodeInit;
